import { RemoteAudioTrack } from 'twilio-video';

import { RemoteAudioDelegator } from '../../../../core/room/participant/media/MediaDelegator';
import { MediaSource, QualityMode } from '../../../../core/room/participant/media/types';
import { deserializeMediaMetadata } from '../../../../core/room/participant/media/utils';
import { detachRemoteTrack } from './utils';

export class TwilioRemoteAudioDelegator implements RemoteAudioDelegator {
  readonly kind = 'audio' as const;
  readonly source: MediaSource = MediaSource.Microphone;
  #track: RemoteAudioTrack;
  #qualityMode: QualityMode | undefined;

  constructor(audioTrack: RemoteAudioTrack) {
    this.#track = audioTrack;

    const { qualityMode, source } = deserializeMediaMetadata(audioTrack.name, this.kind);

    this.#qualityMode = qualityMode;
    this.source = source;
  }

  get sid() {
    return this.#track.sid;
  }

  get isEnabled() {
    return this.#track.isEnabled;
  }

  get qualityMode() {
    return this.#qualityMode;
  }

  attach(element?: HTMLAudioElement): void {
    this.#track.attach(element);
  }

  detach(element?: HTMLAudioElement) {
    if (element) {
      detachRemoteTrack({ track: this.#track, element });
    }
  }

  // Not part of the interface, used for backwards compatibility
  get track() {
    return this.#track;
  }
}
